export default {
  heading: "'Dubai', 'Times New Roman', Times, serif",
  body: "'Dubai', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Ubuntu, 'Helvetica Neue', Oxygen, Cantarell, sans-serif",
}
